/* unplugin-vue-components disabled */import { render } from "./ContactTip.vue?vue&type=template&id=68f517dd&scoped=true&ts=true"
import script from "./ContactTip.vue?vue&type=script&lang=ts"
export * from "./ContactTip.vue?vue&type=script&lang=ts"

import "./ContactTip.vue?vue&type=style&index=0&id=68f517dd&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f517dd"]])

export default __exports__